import CashRegisterShow from './CashRegisterShow'
export {CashRegisterShow}
export default CashRegisterShow
